<template>
  <div class="full-height full-width row">
    <q-drawer
      v-model="state.left.show"
      :mini="!state.left.show || state.left.miniState"
      :width="220"
      :breakpoint="500"
      bordered
      content-class="bg-white column"
    >
      <q-scroll-area class="col">
        <q-list padding>
          <q-item v-show="state.left.miniState == false">
            <q-item-section>
              <q-item-label>Experimental</q-item-label>
              <q-item-label caption style="padding-bottom:8px">
                실험 과제들을 테스트 할 수 있는 페이지 입니다.
              </q-item-label>
            </q-item-section>
          </q-item>
          <q-separator v-show="state.left.miniState == false" />
          <q-item dense v-show="state.left.miniState == false">
            <q-item-section>
              <q-item-label caption>
                테스트
              </q-item-label>
            </q-item-section>
          </q-item>
          <q-item :active="state.page.value == 'math-expression-view'" clickable v-ripple @click="state.page.value = 'math-expression-view'">
            <q-item-section avatar>
              <q-icon name="calculate" />
            </q-item-section>

            <q-item-section>
              수식 인식(2022)
            </q-item-section>

            <q-tooltip v-if="state.left.miniState == true" :offset="[8, 0]">수식 인식(2022)</q-tooltip>
          </q-item>
          <q-item clickable v-ripple disable>
            <q-item-section avatar>
              <q-icon name="request_quote" />
            </q-item-section>

            <q-item-section>
              고지서
            </q-item-section>

            <q-tooltip v-if="state.left.miniState == true" :offset="[8, 0]">고지서</q-tooltip>
          </q-item>
          <q-item clickable v-ripple disable>
            <q-item-section avatar>
              <q-icon name="receipt_long" />
            </q-item-section>

            <q-item-section>
              영수증
            </q-item-section>

            <q-tooltip v-if="state.left.miniState == true" :offset="[8, 0]">영수증</q-tooltip>
          </q-item>
          <q-item clickable v-ripple disable>
            <q-item-section avatar>
              <q-icon name="domain" />
            </q-item-section>

            <q-item-section>
              명함
            </q-item-section>

            <q-tooltip v-if="state.left.miniState == true" :offset="[8, 0]">명함</q-tooltip>
          </q-item>
        </q-list>
      </q-scroll-area>
      <q-separator />
      <q-item clickable v-ripple @click="state.left.miniState = !state.left.miniState">
        <q-item-section avatar>
          <q-icon v-if="state.left.miniState == false" name="chevron_left" />
          <q-icon v-else name="chevron_right" />
        </q-item-section>

        <q-item-section style="color:rgb(125, 125, 125);font-size:12px;">
          POWERED BY SELVAS AI
        </q-item-section>
      </q-item>
    </q-drawer>

    <q-page-container class="column col full-height full-width">
      <q-page class="column col full-height full-width" style="background:rgb(237, 238, 242);padding:10px 30px 25px 30px;overflow:auto;">
        <math-expression-view v-if="state.page.value == 'math-expression-view'"
          ref='math-expression-view'
        />
      </q-page>
    </q-page-container>
  </div>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import MathExpressionView from '@/projects/experimental/views/MathExpression.vue'

export default {
  name: 'App',
  data: function () {
    return {
      state: {
        left: {
          show: true,
          miniState: false
        },
        page: {
          value: 'math-expression-view'
        }
      }
    }
  },
  components: {
    MathExpressionView
  },
  methods: {
  }
}
</script>

<style>
#app {
  position: relative;
  width: 100%;
  height: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding: 0;
  margin: 0;
  overflow: auto;
  background: rgb(239, 239, 239);
}

.body {
  display:flex;
  flex-direction:column;
  height:100%;
  width:100%;
  background: rgb(237, 238, 241);
}

.q-toggle__thumb {
  color: red !important;
}

.q-toggle__thumb:after {
  background: rgb(230, 230, 230) !important;
}

.q-toggle__inner--indet .q-toggle__thumb:after {
  background: rgb(3, 169, 244) !important;
}

.q-toggle__inner--truthy .q-toggle__thumb:after {
  background: #027BE3 !important;
}

.q-toggle__inner.q-toggle__inner--indet {
  color:rgb(41, 182, 246);
}

::-webkit-scrollbar-track
{
	-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
	border-radius: 10px;
	background-color: #F5F5F5;
}

::-webkit-scrollbar
{
	width: 6px;
  height: 6px;
	background-color: #F5F5F5;
}

::-webkit-scrollbar-thumb
{
	border-radius: 10px;
	-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
	background-color: #555;
}

</style>
